import React from 'react';

import { routeDirectory } from 'modules';
import { RouteObject } from 'react-router-dom';
import { LogInActivity } from './LogInActivity/LogInActivity';
import { RegisterActivity } from './RegisterActivity/RegisterActivity';
import { ForgotPasswordActivity } from './ForgotPasswordActivity/ForgotPasswordActivity';



export const routes: RouteObject[] = [
  {
    path: routeDirectory.auth.logIn.raw,
    element: <LogInActivity />
  },
  {
    path: routeDirectory.auth.register.raw,
    element: <RegisterActivity />
  },
  {
    path: routeDirectory.auth.forgotPassword.raw,
    element: <ForgotPasswordActivity />
  }
];
